import { asyncLoad } from '@util'

const AsyncManage = asyncLoad(() =>
  import('@components/LocalMerchant/MerchantNameCard/Manage')
)

export default {
  path: 'nameCardManage',
  indexRoute: {
    component: AsyncManage
  },
  stat: '商家名片小程序/商家名片管理'
}
